import { render, staticRenderFns } from "./hue2-promo.vue?vue&type=template&id=497ab65b&scoped=true&"
import script from "./hue2-promo.vue?vue&type=script&lang=js&"
export * from "./hue2-promo.vue?vue&type=script&lang=js&"
import style0 from "./hue2-promo.vue?vue&type=style&index=0&id=497ab65b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ab65b",
  null
  
)

export default component.exports